export class ServiceGroup {
  key:string;
  value:number;
  selected:boolean;
  
  constructor(_key:string, _value:number, _selected:boolean){
    this.key = _key;
    this.value = _value;
    this.selected = _selected;
  }
}
